module.exports = __webpack_public_path__ + "static/media/mapa-recorrido.52cc2615.jpg";